import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatMessageEntity} from "@dropDesk/domain/entities/internal_chat/messages/internal_chat_message_entity";
import {Observable} from "rxjs";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";

@injectable()
export class SubscriptionUploadFileInternalChatUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(message: InternalChatMessageEntity): Observable<InternalChatMessageEntity> {
        return this._repository.subscriptionUploadFile(message);
    }
}
